// extracted by mini-css-extract-plugin
export const featureCard = "feature-card-module--featureCard--1tvyC";
export const breakEarly = "feature-card-module--breakEarly--1SnkT";
export const dark = "feature-card-module--dark--3iwg7";
export const title = "feature-card-module--title--1W1OE";
export const heading = "feature-card-module--heading--1okky";
export const description = "feature-card-module--description--1j4JO";